module.exports = __webpack_public_path__ + "catalog/items/cleaningcart/cleaning_cart.png";